import { BehaviorSubject, Subject, Observable } from "rxjs";

export enum EndpointsName {
  CONFIG = "/config",
  LIMITS = "/limits",
  HINTS = "/hints",
  BBF = "",
  GLOBAL = "/global",
  MAINTENANCE = "/maintenance",
  HISTORICAL = "/historical",
}

export enum Roles {
  ADMIN = "ADMIN",
  LC = "LC",
  OPERATOR = "OPERATOR",
  GLOBALVIEWER = "GLOBAL-VIEWER",
}
export interface User {
  username: string;
  factoryList: string[];
  factory: string;
  roles: Map<string, Roles>;
  roleInCurrentFactory: Roles;
  credentials: UserCredentials;
  cognitoRoles?: Map<string, string>;
  cognitoRoleInCurrentFactory?: string;
}

export interface UserCredentials {
  accessToken?: any;
  idToken?: any;
  secretAccessKey: string;
  accessKeyId: string;
  sessionToken: string;
  identityId?: string;
}

export interface UserConfig {
  user: User;
  userObservable: BehaviorSubject<User>;
  factoryChangeObservable: Subject<string>;
  userIsActiveInterval: number | null;
  setUser(user: User): void;
  setUserCredentials(credentials: UserCredentials): void;
  getUserCredentials(): UserCredentials;
  changeFactory(factory: string): Promise<string> | void;
  getUserData(): User;
  getAsyncUserData(): Promise<User>;
  getObservableUserData(): Observable<User>;
  getFactoryChangeObservable(): Observable<string>;
  getUserIsActiveInterval(): number | null;
}
